// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__txSu9","btn":"Tabs_btn__Z6HA-","active":"Tabs_active__v-25r"};